import { render, staticRenderFns } from "./NotificacaoModule.vue?vue&type=template&id=3e628845"
import script from "./NotificacaoModule.vue?vue&type=script&lang=js"
export * from "./NotificacaoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports